import { BaseIcon } from './BaseIcon';

export default class TrashIcon extends BaseIcon {
    name() { return 'delete_outline'; };
}
